import { render, staticRenderFns } from "./DMPAdd.vue?vue&type=template&id=ac36df66&scoped=true"
import script from "./DMPAdd.vue?vue&type=script&lang=js"
export * from "./DMPAdd.vue?vue&type=script&lang=js"
import style0 from "./DMPAdd.vue?vue&type=style&index=0&id=ac36df66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac36df66",
  null
  
)

export default component.exports